import React, { useContext, useState, useEffect } from "react";
import { ConfigContext } from "../Context/configContext";

export interface LanguageOption {
  value: string;
  label: string;
}

export const useLanguages = () => {
  const { config } = useContext(ConfigContext);
  const [languages, setLanguages] = useState<LanguageOption[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchLanguages = async () => {
    try {
      if (!config?.regionUrl) {
        throw new Error('Region URL not configured');
      }

      const response = await fetch(config.regionUrl);
      if (!response.ok) {
        throw new Error('Failed to fetch language options');
      }

      const data = await response.json();
      if (data && data.languages) {
        const formattedOptions = Object.entries(data.languages).map(([value, label]) => ({
          value,
          label: label as string
        }));
        setLanguages(formattedOptions);
      }
    } catch (err) {
      console.error('Error fetching language options:', err);
      setError(err instanceof Error ? err.message : 'Failed to fetch languages');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLanguages();
  }, [config?.regionUrl]);

  return {
    languages,
    loading,
    error,
    fetchLanguages
  };
};
